import type { AvatarLabExpression } from "../CloudeeAvatar";

export type ToolAvatarKind =
  | "thinking"
  | "read"
  | "edit"
  | "command"
  | "search"
  | "code-search"
  | "other"
  | "dynamic-tool"
  | "agent-tool"
  | "tone-tool"
  | "mixed";

const TOOL_EXPRESSION: Record<ToolAvatarKind, AvatarLabExpression> = {
  thinking: "skeptical-left",
  read: "attentive-left",
  edit: "angry-left",
  command: "angry-right",
  search: "far-right-glance",
  "code-search": "curious-left",
  other: "small-attentive",
  "dynamic-tool": "surprised-left",
  "agent-tool": "playful-right",
  "tone-tool": "joyful-wide",
  mixed: "wide-down-left",
};

export function resolveToolAvatarExpression(
  kind: ToolAvatarKind,
  failed = false,
): AvatarLabExpression {
  return failed ? "uneasy-left" : TOOL_EXPRESSION[kind];
}
